import SpriteSymbol from "../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "summary",
  "use": "summary-usage",
  "viewBox": "0 0 30 38",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 38\" id=\"summary\"><path d=\"M7.867 17.061h7.352v-3.697H7.867v3.697zm0 5.504H22.57v-3.698H7.867v3.698zm0 5.503H22.57v-3.697H7.867v3.697zM28.075 2.357h-7.353V.55H9.715v1.806H2.363c-.487 0-.91.179-1.268.537a1.784 1.784 0 00-.538 1.311v31.173c0 .516.18.953.538 1.311.358.358.78.538 1.268.538h25.712c.487 0 .91-.18 1.268-.538.359-.358.538-.795.538-1.311V4.205c0-.515-.18-.953-.538-1.31a1.735 1.735 0 00-1.268-.538zm-1.849 31.215H4.212V6.054h5.503V7.86h11.007V6.054h5.504v27.518z\" fill=\"#214263\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./icons/summary.svg
// module id = 1015
// module chunks = 0